import { render } from "./app-button-dropdown.vue?vue&type=template&id=63d65932&scoped=true"
import script from "./app-button-dropdown.vue?vue&type=script&lang=js"
export * from "./app-button-dropdown.vue?vue&type=script&lang=js"

import "./app-button-dropdown.vue?vue&type=style&index=0&id=63d65932&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d65932"],['__file',"src/views/components/button/app-button-dropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63d65932"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63d65932', __exports__)) {
    console.log('reload')
    api.reload('63d65932', __exports__)
  }
  
  module.hot.accept("./app-button-dropdown.vue?vue&type=template&id=63d65932&scoped=true", () => {
    console.log('re-render')
    api.rerender('63d65932', render)
  })

}


export default __exports__